(() => {

  var AccordionApp = (() => {
    var toggle = (trigger) => {
      if (!trigger) return;
      const wrapper = document.querySelector(`[js-load-more-wrapper=${trigger.getAttribute('js-load-more-trigger')}]`);
      if (!wrapper) return;
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active');
        wrapper.classList.remove('active');
        wrapper.style.maxHeight = '0px';
      } else {
        trigger.classList.add('active');
        wrapper.classList.add('active');
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-load-more-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          toggle(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var TabApp = (() => {
    var open = (container, tab_id) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        element.classList.remove('active');
        if (String(element.getAttribute('js-tab-header')) === String(tab_id)) {
          element.classList.add('active');
        }
        if (String(element.getAttribute('js-tab-body')) === String(tab_id)) {
          element.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab]'), element.getAttribute('js-tab-header'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      AccordionApp.init();
      TabApp.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();